import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa";
const Leadership = () => {
  
  const directors = [
    {
      name: "Venkata Ramana Panda",
      title: "Chairman",
      image: "https://ik.imagekit.io/kqumni8l2/Leadership/1_.png?updatedAt=1745813970968",
      bgColor: "#f2f2f2",
      linkedin:""
    },
    {
      name: "Aadi Narayana Yadlapalli",
      title: "Director Delivery",
      image: "https://ik.imagekit.io/kqumni8l2/Leadership/5.png?updatedAt=1745813970579",
      bgColor: "#0a2640",
      linkedin:"/"
    },
    {
      name: "Bharat",
      title: "Director",
      image: "/api/placeholder/400/400",
      bgColor: "#0a2640",
      linkedin:"/"
    },
    {
      name: "SathyaKishore Tammineedi",
      title: "Director Finance",
      image: "https://ik.imagekit.io/kqumni8l2/Leadership/3.png?updatedAt=1745813970574",
      bgColor: "#f2f2f2",
      linkedin:"/"
    },
    {
      name: "Prem Dasari",
      title: "Managing Director",
      image: "https://ik.imagekit.io/kqumni8l2/Leadership/2.png?updatedAt=1745813970450",
      bgColor: "#0a2640",
      linkedin:""
    },
    {
      name: "Sarah Johnson",
      title: "Director",
      image: "/api/placeholder/400/400",
      bgColor: "#0a2640",
      linkedin:""
    }
  ];

   const GlobalLeaders = [
    {
      name: "Prem Dasari",
      title: "Cheif Executive Officer",
      image: "https://ik.imagekit.io/kqumni8l2/Leadership/2.png?updatedAt=1745813970450",
      bgColor: "#f2f2f2",
      linkedin:""
    },
    {
      name: "Santhya Nair",
      title: "Regional Business Head",
      image: "https://ik.imagekit.io/kqumni8l2/Leadership/4.png?updatedAt=1745813970976",
      bgColor: "#0a2640",
      linkedin:"/"
    },
    {
      name: "Agung",
      title: "Director",
      image: "/api/placeholder/400/400",
      bgColor: "#0a2640",
      linkedin:"/"
    },
    {
      name: "Jenny",
      title: " Infor Functional Consultant, Senior (Finance)",
      image: "https://ik.imagekit.io/kqumni8l2/Leadership/jenny.png?updatedAt=1745813975324",
      bgColor: "#f2f2f2",
      linkedin:"/"
    },
    {
      name: "Maheshnath M",
      title: "Director",
      image: "Talent Acquisition & Hr Manager",
      bgColor: "#0a2640",
      linkedin:""
    },
    {
      name: "Sarah Johnson",
      title: "Director",
      image: "/api/placeholder/400/400",
      bgColor: "#0a2640",
      linkedin:""
    }
  ];

  return (
    <div className="w-full bg-white py-10 px-4 md:px-8 lg:px-16">
      <h2 className="text-[#081724] text-4xl">Meet the leaders driving our <br />
global teams</h2>
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-[#29b6f6] mb-10">Board of Directors</h1>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {directors.map((director, index) => (
            <div key={index} className="relative mb-6">
              <div className="h-80 relative overflow-hidden" style={{ backgroundColor: director.bgColor }}>
                <img 
                  src={director.image} 
                  alt={director.name} 
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="py-3">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-md font-semibold text-[#0c0c3e] ">{director.name}</h3>
                    <p className="text-gray-600 text-sm">{director.title}</p>
                  </div>
                  <div className="text-[#29b6f6]">
                  <Link to={director.linkedin}><FaLinkedin  size={24} /></Link>   
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>


            <div className="max-w-7xl mx-auto mt-11">
        <h1 className="text-2xl md:text-3xl font-bold text-[#29b6f6] mb-10">Global Leadership</h1>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {GlobalLeaders.map((director, index) => (
            <div key={index} className="relative mb-6">
              <div className="h-80 relative overflow-hidden" style={{ backgroundColor: director.bgColor }}>
                <img 
                  src={director.image} 
                  alt={director.name} 
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="py-3">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-md font-semibold text-[#0c0c3e] ">{director.name}</h3>
                    <p className="text-gray-600 text-sm">{director.title}</p>
                  </div>
                  <div className="text-[#29b6f6]">
                  <Link to={director.linkedin}><FaLinkedin  size={24} /></Link>   
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}

export default Leadership;